/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoadingCapabilitiesAvailability } from './LoadingCapabilitiesAvailability';
import {
    LoadingCapabilitiesAvailabilityFromJSON,
    LoadingCapabilitiesAvailabilityFromJSONTyped,
    LoadingCapabilitiesAvailabilityToJSON,
    LoadingCapabilitiesAvailabilityToJSONTyped,
} from './LoadingCapabilitiesAvailability';
import type { Location } from './Location';
import {
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
    LocationToJSONTyped,
} from './Location';

/**
 * 
 * @export
 * @interface ModifySavedLocationRequest
 */
export interface ModifySavedLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof ModifySavedLocationRequest
     */
    savedLocationId: string;
    /**
     * 
     * @type {Location}
     * @memberof ModifySavedLocationRequest
     */
    location: Location;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof ModifySavedLocationRequest
     */
    locationHasDock?: LoadingCapabilitiesAvailability;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof ModifySavedLocationRequest
     */
    locationHasForklift?: LoadingCapabilitiesAvailability;
}



/**
 * Check if a given object implements the ModifySavedLocationRequest interface.
 */
export function instanceOfModifySavedLocationRequest(value: object): value is ModifySavedLocationRequest {
    if (!('savedLocationId' in value) || value['savedLocationId'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    return true;
}

export function ModifySavedLocationRequestFromJSON(json: any): ModifySavedLocationRequest {
    return ModifySavedLocationRequestFromJSONTyped(json, false);
}

export function ModifySavedLocationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModifySavedLocationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'savedLocationId': json['savedLocationId'],
        'location': LocationFromJSON(json['location']),
        'locationHasDock': json['locationHasDock'] == null ? undefined : LoadingCapabilitiesAvailabilityFromJSON(json['locationHasDock']),
        'locationHasForklift': json['locationHasForklift'] == null ? undefined : LoadingCapabilitiesAvailabilityFromJSON(json['locationHasForklift']),
    };
}

  export function ModifySavedLocationRequestToJSON(json: any): ModifySavedLocationRequest {
      return ModifySavedLocationRequestToJSONTyped(json, false);
  }

  export function ModifySavedLocationRequestToJSONTyped(value?: ModifySavedLocationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'savedLocationId': value['savedLocationId'],
        'location': LocationToJSON(value['location']),
        'locationHasDock': LoadingCapabilitiesAvailabilityToJSON(value['locationHasDock']),
        'locationHasForklift': LoadingCapabilitiesAvailabilityToJSON(value['locationHasForklift']),
    };
}

